import axios from 'axios'

export default axios.create(
    {
        baseURL: 'https://ankauf.autowinkler.at/auto-winkler/cpa/api/v1',
        headers: {
            'Content-Type': 'application/json'
        }
    }
)